<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="550"
      hide-overlay
      :persistent="true"
    >
      <v-card class="body-1">
        <v-toolbar flat :color="lessonColor">
          <v-toolbar-title>Ответ</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              icon
              @click="acceptClosePanel"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container grid-list-md>
          <v-row class="d-flex flex-lg-row flex-xl-row flex-md-row flex-column-reverse">
            <v-col lg="12" md="12" xl="12" sm="12">
              <v-row class="d-flex flex-lg-row flex-xl-row flex-md-row flex-column-reverse">
                <v-col>
                  <div>
                    <quill v-model="answer.text"
                      v-if="dialog"
                      output="html"
                      @text-change="textOnChange"
                      :config="quillConfig"></quill>
                  </div>
                  <div v-if="files && files.length">
                    <p v-for="(file, index) of files"
                      class="file-row"
                      :key="index">
                      <span>{{ file.name }}</span>
                      <span class="file-buttons">
                        <v-btn :small="true"
                          @click="deleteFile(index)"
                          icon>
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </span>
                    </p>
                  </div>
                  <div v-if="allowAnswerAction('file')">
                    <v-btn text
                      @click="clickOnFile"
                      style="margin-top: 15px;"
                      color="accent">
                      + Файл
                    </v-btn>
                    <input
                      type="file"
                      ref="fileUploader"
                      accept="*"
                      class="d-none"
                      @change="addFile"
                    />
                  </div>
                  <v-alert type="info" v-if="allowAnswerAction('file')"
                    class="body-2 mt-3" dense outlined>
                    Разрешено добавлять файлы объемом не более 50 МБ
                  </v-alert>
                </v-col>
              </v-row>
            </v-col>
            <v-progress-linear determinate v-model="loadingPercent" v-if="loading">
            </v-progress-linear>
          </v-row>
        </v-container>
        <v-card-actions class="d-flex panel-buttons">
          <v-spacer></v-spacer>
          <v-btn text @click="acceptClosePanel">Закрыть</v-btn>
          <v-btn text @click="saveAnswer(true)"
            class="accent-btn" :class="{'text--secondary':loading}"
            :disabled="loading"
            color="accent">
            Сохранить и Отправить
          </v-btn>
          <v-btn text @click="saveAnswer(false)"
            class="accent-btn" :class="{'text--secondary':loading}"
            :disabled="loading"
            color="accent">
            Сохранить как черновик
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      <v-snackbar
        v-model="showNotification"
        :top="true"
        :right="true"
        :timeout="3000"
      >
        {{ notificationText }}
      </v-snackbar>
    </v-dialog>
    <v-dialog v-model="showAcceptModal"
      hide-overlay
      max-width="250"
      persistent
    >
      <v-card>
        <v-container>
          {{ acceptText }}
        </v-container>
        <v-card-actions v-if="showAcceptModal" class="align-center">
          <v-spacer></v-spacer>
          <v-btn text @click="showAcceptModal=false">Нет</v-btn>
          <v-btn text @click="acceptFunction">Да</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Lesson from '../../api/Lesson';


export default {
  name: 'NewTaskAnswerPopup',
  props: ['type', 'value', 'lessonColor', 'lesson'],
  data: () => ({
    loading: false,
    answer: {},
    loadingPercent: 0,
    totalPercentLoaded: 0,
    showAcceptModal: false,
    acceptText: '',
    acceptKey: '',
    textWasChanged: false,
    files: [],
    notificationText: '',
    showNotification: false,
  }),
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    quillConfig() {
      return {
        placeholder: 'Текст ответа',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],

            [{ list: 'ordered' }, { list: 'bullet' }],

            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ font: [] }],
            ['link'],
          ],
        },
      };
    },
    ...mapGetters(['currentUser', 'UISettings']),
  },
  methods: {
    async saveAnswer(send) {
      try {
        this.loading = true;
        const data = {
          userId: this.currentUser.id,
          text: this.answer.text,
          type: this.type,
        };
        const newAnswerData = await Lesson.addAnswer(
          this.lesson.id,
          data,
        );
        const newAnswer = newAnswerData.data;
        this.answer = newAnswer;
        let wasError = false;
        if (this.files.length) {
          this.loadingPercent = 0;
          let totalSize = 0;
          for (const f of this.files) {
            totalSize += f.size;
          }
          this.totalPercentLoaded = 0;
          for (const file of this.files) {
            const base64 = await this.toBase64(file);
            const fileData = {
              name: file.name,
              data: base64,
              scopeUserId: this.currentUser.id,
            };
            let percentStep = (file.size / totalSize) * 100;
            const additionalStep = percentStep * 0.1;
            percentStep *= 0.9;
            try {
              await Lesson.uploadAnswerFile(this.lesson.id, newAnswer.id, fileData, (evt) => {
                const totalIncrement = (percentStep * (evt.loaded / evt.total));
                this.loadingPercent = this.totalPercentLoaded + totalIncrement;
              });
            } catch (err) {
              wasError = true;
              if (err.response && err.response.status === 413) {
                this.showLargeFileNotification(file.size);
              } else {
                this.showErrorNotification();
              }
            }
            this.totalPercentLoaded += (percentStep + additionalStep);
            this.loadingPercent = this.totalPercentLoaded;
          }
        } else {
          this.loadingPercent = 100;
        }
        if (send && !wasError) {
          await this.setSendStatus(newAnswer);
        }
        await this.updateAnswer();
        this.dialog = false;
        this.answer = { text: '' };
        this.files = [];
        this.loading = false;
      } catch (error) {
        if (
          error.response
          && error.response.data
          && error.response.data.message === 'Answer already exists') {
          this.showExistNotification();
        } else {
          this.showErrorNotification();
        }
        this.loading = false;
      }
    },

    async setSendStatus(answer) {
      await Lesson.setAnswerSendStatus(this.lesson.id, answer.id, {
        userId: this.currentUser.id,
      });
    },

    clickOnFile() {
      this.$refs.fileUploader.click();
    },

    addFile(e) {
      const file = e.target.files[0];
      if (file && file.size > 50000000) {
        this.showLargeFileNotification(file.size);
        return;
      }
      this.files.push(file);
    },

    deleteFile(index) {
      this.files.splice(index, 1);
    },

    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.toString().replace(/^data:(.*,)?/, ''));
        reader.onerror = error => reject(error);
      });
    },

    async updateAnswer() {
      const answerData = await Lesson.getAnswer(this.lesson.id, this.answer.id, {
        scopeUserId: this.currentUser.id,
      });
      this.$emit('update', answerData.data);
    },

    allowAnswerAction(action) {
      return !!this.UISettings.answerActions[action];
    },

    acceptClosePanel() {
      if (this.textWasChanged || this.files.length) {
        this.acceptText = 'Вы уверены что хотите закрыть окно? Все несохраненные изменения будут утеряны.';
        this.acceptKey = 'closePanel';
        this.showAcceptModal = true;
      } else {
        this.closePanel();
      }
    },

    async acceptFunction() {
      if (this[this.acceptKey]) {
        await this[this.acceptKey]();
      }
    },

    closePanel() {
      this.showAcceptModal = false;
      this.textWasChanged = false;
      this.answer = {};
      this.dialog = false;
    },

    textOnChange() {
      this.textWasChanged = true;
    },

    showLargeFileNotification(actualFileSize) {
      this.notificationText = 'Размер файла не должен превышать 50МБ.';
      if (actualFileSize) {
        const fileSizeInMb = Math.floor(actualFileSize / 1e+5) / 10;
        this.notificationText += ` Размер загружаемого файла: ${fileSizeInMb}МБ.`
      }
      this.showNotification = true;
    },

    showErrorNotification() {
      this.notificationText = 'Произошла ошибка';
      this.showNotification = true;
    },

    showExistNotification() {
      this.notificationText = 'Ответ на задание уже существует';
      this.showNotification = true;
    },
  },
};
</script>

<style scoped lang="less">
  .panel-buttons {
    @media (max-width: 591px) {
      flex-direction: column-reverse;
    }
  }
</style>
